// Generated by scripts/generate-responsive-images.mjs; original captures remain unchanged.
const responsiveImages: Record<string, { src: string; srcSet: string; width: number; height: number }> = {
  "/work/mizuro-glass-2026-10-18.jpg": {
    "src": "/images/responsive/mizuro-glass-2026-10-18-800.webp",
    "srcSet": "/images/responsive/mizuro-glass-2026-10-18-480.webp 480w, /images/responsive/mizuro-glass-2026-10-18-800.webp 800w, /images/responsive/mizuro-glass-2026-10-18-1200.webp 1200w, /images/responsive/mizuro-glass-2026-10-18-1600.webp 1600w",
    "width": 1920,
    "height": 1536
  },
  "/work/sierra-homes-2026-09.jpg": {
    "src": "/images/responsive/sierra-homes-2026-09-800.webp",
    "srcSet": "/images/responsive/sierra-homes-2026-09-480.webp 480w, /images/responsive/sierra-homes-2026-09-800.webp 800w, /images/responsive/sierra-homes-2026-09-1200.webp 1200w, /images/responsive/sierra-homes-2026-09-1600.webp 1600w",
    "width": 1920,
    "height": 1536
  },
  "/work/settle-2026-09.jpg": {
    "src": "/images/responsive/settle-2026-09-800.webp",
    "srcSet": "/images/responsive/settle-2026-09-480.webp 480w, /images/responsive/settle-2026-09-800.webp 800w, /images/responsive/settle-2026-09-1200.webp 1200w, /images/responsive/settle-2026-09-1600.webp 1600w",
    "width": 1920,
    "height": 1536
  },
  "/work/captures-by-mari-2026-09-12.jpg": {
    "src": "/images/responsive/captures-by-mari-2026-09-12-800.webp",
    "srcSet": "/images/responsive/captures-by-mari-2026-09-12-480.webp 480w, /images/responsive/captures-by-mari-2026-09-12-800.webp 800w, /images/responsive/captures-by-mari-2026-09-12-1200.webp 1200w, /images/responsive/captures-by-mari-2026-09-12-1600.webp 1600w",
    "width": 1920,
    "height": 1536
  },
  "/work/stax-2026-09.jpg": {
    "src": "/images/responsive/stax-2026-09-800.webp",
    "srcSet": "/images/responsive/stax-2026-09-480.webp 480w, /images/responsive/stax-2026-09-800.webp 800w, /images/responsive/stax-2026-09-1200.webp 1200w, /images/responsive/stax-2026-09-1600.webp 1600w",
    "width": 1920,
    "height": 1536
  },
  "/work/aws-cdk-ai-analysis.png": {
    "src": "/images/responsive/aws-cdk-ai-analysis-800.webp",
    "srcSet": "/images/responsive/aws-cdk-ai-analysis-480.webp 480w, /images/responsive/aws-cdk-ai-analysis-800.webp 800w, /images/responsive/aws-cdk-ai-analysis-1200.webp 1200w",
    "width": 1500,
    "height": 1200
  },
  "/work/son-of-astraeus.png": {
    "src": "/images/responsive/son-of-astraeus-800.webp",
    "srcSet": "/images/responsive/son-of-astraeus-480.webp 480w, /images/responsive/son-of-astraeus-800.webp 800w, /images/responsive/son-of-astraeus-1200.webp 1200w",
    "width": 1500,
    "height": 1200
  },
  "/work/scrumlord.png": {
    "src": "/images/responsive/scrumlord-800.webp",
    "srcSet": "/images/responsive/scrumlord-480.webp 480w, /images/responsive/scrumlord-800.webp 800w, /images/responsive/scrumlord-1200.webp 1200w",
    "width": 1500,
    "height": 1200
  },
  "/work/yoink.png": {
    "src": "/images/responsive/yoink-800.webp",
    "srcSet": "/images/responsive/yoink-480.webp 480w, /images/responsive/yoink-800.webp 800w, /images/responsive/yoink-1200.webp 1200w",
    "width": 1280,
    "height": 1024
  },
  "/work/databryd.png": {
    "src": "/images/responsive/databryd-800.webp",
    "srcSet": "/images/responsive/databryd-480.webp 480w, /images/responsive/databryd-800.webp 800w, /images/responsive/databryd-1200.webp 1200w",
    "width": 1500,
    "height": 1200
  },
  "/work/scale-of-the-universe.png": {
    "src": "/images/responsive/scale-of-the-universe-800.webp",
    "srcSet": "/images/responsive/scale-of-the-universe-480.webp 480w, /images/responsive/scale-of-the-universe-800.webp 800w, /images/responsive/scale-of-the-universe-1200.webp 1200w, /images/responsive/scale-of-the-universe-1600.webp 1600w",
    "width": 1652,
    "height": 1220
  },
  "/work/sorting-algorithms.png": {
    "src": "/images/responsive/sorting-algorithms-800.webp",
    "srcSet": "/images/responsive/sorting-algorithms-480.webp 480w, /images/responsive/sorting-algorithms-800.webp 800w, /images/responsive/sorting-algorithms-1200.webp 1200w, /images/responsive/sorting-algorithms-1600.webp 1600w",
    "width": 1653,
    "height": 1266
  },
  "/work/neural-network-flow.png": {
    "src": "/images/responsive/neural-network-flow-800.webp",
    "srcSet": "/images/responsive/neural-network-flow-480.webp 480w, /images/responsive/neural-network-flow-800.webp 800w, /images/responsive/neural-network-flow-1200.webp 1200w, /images/responsive/neural-network-flow-1600.webp 1600w",
    "width": 1643,
    "height": 957
  },
  "/work/gravitational-lensing.png": {
    "src": "/images/responsive/gravitational-lensing-800.webp",
    "srcSet": "/images/responsive/gravitational-lensing-480.webp 480w, /images/responsive/gravitational-lensing-800.webp 800w, /images/responsive/gravitational-lensing-1200.webp 1200w",
    "width": 1553,
    "height": 1205
  },
  "/work/humanity-writing-itself.png": {
    "src": "/images/responsive/work-humanity-writing-itself-800.webp",
    "srcSet": "/images/responsive/work-humanity-writing-itself-480.webp 480w, /images/responsive/work-humanity-writing-itself-800.webp 800w, /images/responsive/work-humanity-writing-itself-1200.webp 1200w, /images/responsive/work-humanity-writing-itself-1600.webp 1600w",
    "width": 3446,
    "height": 1838
  },
  "/work/harris-ranch-beef.png": {
    "src": "/images/responsive/harris-ranch-beef-800.webp",
    "srcSet": "/images/responsive/harris-ranch-beef-480.webp 480w, /images/responsive/harris-ranch-beef-800.webp 800w, /images/responsive/harris-ranch-beef-1200.webp 1200w, /images/responsive/harris-ranch-beef-1600.webp 1600w",
    "width": 1758,
    "height": 1265
  },
  "/work/strategysource.png": {
    "src": "/images/responsive/strategysource-800.webp",
    "srcSet": "/images/responsive/strategysource-480.webp 480w, /images/responsive/strategysource-800.webp 800w, /images/responsive/strategysource-1200.webp 1200w, /images/responsive/strategysource-1600.webp 1600w",
    "width": 2560,
    "height": 1700
  },
  "/work/pitstop-stations.png": {
    "src": "/images/responsive/pitstop-stations-800.webp",
    "srcSet": "/images/responsive/pitstop-stations-480.webp 480w, /images/responsive/pitstop-stations-800.webp 800w, /images/responsive/pitstop-stations-1200.webp 1200w, /images/responsive/pitstop-stations-1600.webp 1600w",
    "width": 2560,
    "height": 1900
  },
  "/work/emulator-arcade.png": {
    "src": "/images/responsive/emulator-arcade-800.webp",
    "srcSet": "/images/responsive/emulator-arcade-480.webp 480w, /images/responsive/emulator-arcade-800.webp 800w, /images/responsive/emulator-arcade-1200.webp 1200w",
    "width": 1280,
    "height": 1024
  },
  "/work/jz-concrete.png": {
    "src": "/images/responsive/jz-concrete-800.webp",
    "srcSet": "/images/responsive/jz-concrete-480.webp 480w, /images/responsive/jz-concrete-800.webp 800w, /images/responsive/jz-concrete-1200.webp 1200w",
    "width": 1280,
    "height": 1024
  },
  "/work/llm-token-counter.png": {
    "src": "/images/responsive/llm-token-counter-800.webp",
    "srcSet": "/images/responsive/llm-token-counter-480.webp 480w, /images/responsive/llm-token-counter-800.webp 800w, /images/responsive/llm-token-counter-1200.webp 1200w",
    "width": 1280,
    "height": 1024
  },
  "/blog_images/neural-network-flow/neural_network_thumbnail.png": {
    "src": "/images/responsive/neural_network_thumbnail-800.webp",
    "srcSet": "/images/responsive/neural_network_thumbnail-480.webp 480w, /images/responsive/neural_network_thumbnail-800.webp 800w, /images/responsive/neural_network_thumbnail-1200.webp 1200w, /images/responsive/neural_network_thumbnail-1600.webp 1600w",
    "width": 1643,
    "height": 957
  },
  "/images/real-estate/exterior.jpg": {
    "src": "/images/responsive/exterior-800.webp",
    "srcSet": "/images/responsive/exterior-480.webp 480w, /images/responsive/exterior-800.webp 800w, /images/responsive/exterior-1200.webp 1200w, /images/responsive/exterior-1440.webp 1440w, /images/responsive/exterior-1600.webp 1600w",
    "width": 2000,
    "height": 1333
  },
  "/experience_thumbnails/humanity-writing-itself.png": {
    "src": "/images/responsive/humanity-writing-itself-800.webp",
    "srcSet": "/images/responsive/humanity-writing-itself-480.webp 480w, /images/responsive/humanity-writing-itself-800.webp 800w, /images/responsive/humanity-writing-itself-1200.webp 1200w, /images/responsive/humanity-writing-itself-1600.webp 1600w",
    "width": 3446,
    "height": 1838
  }
};

export function responsiveImageProps(src: string) {
  return responsiveImages[src] ?? { src };
}
